import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

const optionLabel = (option) => {
  if (!option) return '';
  const parts = [option.accountName, option.bac, option.address].filter(Boolean);
  return parts.join(' | ');
};

const BuySellAccountPicker = ({
  label,
  helperText,
  placeholder,
  searchOptions,
  searchLoading,
  inputValue,
  onInputValueChange,
  onSearchQueryChange,
  selectedAccount,
  onAccountChange,
}) => (
  <Autocomplete
    options={searchOptions}
    loading={searchLoading}
    value={selectedAccount}
    onChange={(_event, value) => onAccountChange(value)}
    inputValue={inputValue}
    onInputChange={(_event, value, reason) => {
      // Keep the textbox stable. Only trigger network search on real user typing.
      onInputValueChange?.(value);
      if (reason === 'input' || reason === 'clear') onSearchQueryChange?.(value);
    }}
    getOptionLabel={optionLabel}
    isOptionEqualToValue={(option, value) => option?.accountId === value?.accountId}
    filterOptions={(options) => options}
    renderInput={(params) => (
      <TextField
        {...params}
        fullWidth
        label={label}
        placeholder={placeholder}
        helperText={helperText}
      />
    )}
  />
);

export default BuySellAccountPicker;
